import { create } from 'zustand';

type WizardStep = 1 | 2 | 3 | 4 | 5;

interface UiState {
  // Wizard navigation
  currentStep: WizardStep;
  setCurrentStep: (step: WizardStep) => void;

  // Auto-save feedback
  isSaving: boolean;
  lastSaved: string | null;   // ISO timestamp
  saveError: string | null;   // non-null when last save failed
  setIsSaving: (saving: boolean) => void;
  setLastSaved: (timestamp: string) => void;
  setSaveError: (error: string | null) => void;

  // Diagram viewer
  activeDiagramType: string | null;
  setActiveDiagramType: (type: string | null) => void;

  // Toast notifications
  toast: string | null;
  showToast: (message: string, durationMs?: number) => void;
  clearToast: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  currentStep: 1,
  setCurrentStep: (step) => set({ currentStep: step }),

  isSaving: false,
  lastSaved: null,
  saveError: null,
  setIsSaving: (saving) => set({ isSaving: saving }),
  setLastSaved: (timestamp) => set({ lastSaved: timestamp, saveError: null }),
  setSaveError: (error) => set({ saveError: error }),

  activeDiagramType: null,
  setActiveDiagramType: (type) => set({ activeDiagramType: type }),

  toast: null,
  showToast: (message, durationMs = 3000) => {
    set({ toast: message });
    setTimeout(() => set({ toast: null }), durationMs);
  },
  clearToast: () => set({ toast: null }),
}));
